import { Spin } from 'antd'
import React, { CSSProperties } from 'react'

type Props = { small?: boolean; style?: CSSProperties }

export const Loader: React.FC<Props> = ({ small = false, style }) => (
  <Spin style={style} size={small ? 'small' : 'default'} />
)
